import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/carry_ins`
const orders_accepts_carry_ins_registration = {
  namespaced: true,
  actions: {
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/registrations/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}/registrations`
        Vue.$http.put(api_path, params,).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  }
}
export default orders_accepts_carry_ins_registration
